export default {
  C: "Do",
  CSharp: "Do♯",
  D: "Ré",
  DFlat: "Ré♭",
  DSharp: "Ré♯",
  E: "Mi",
  EFlat: "Mi♭",
  F: "Fa",
  FSharp: "Fa♯",
  G: "Sol",
  GFlat: "Sol♭",
  GSharp: "Sol♯",
  A: "La",
  AFlat: "La♭",
  ASharp: "La♯",
  B: "Si",
  BFlat: "Si♭",

  correctExcl: "C'est juste !",
  wrongExcl: "C'est faux !",

  ABORT: "ABANDONNER LA MANCHE",

  lastRound: "Dernière manche",
  score: "Points",
  accuracy: "Précision",
  correct: "juste",
  wrong: "fausse",

  START: "COMMENCER",
  settings: "Options",
  ROUND_LENGTH: "DURÉE DE LA MANCHE",
  NOTE_INPUT: "SAISIE DE NOTES",
  CLEF: "CLÉ",
  DIFFICULTY: "DEGRÉ DE DIFFICULTÉ",
  ACCIDENTALS: "ALTÉRATIONS",
  LANGUAGE: "LANGUE",
  twentySeconds: "20''",
  oneMinute: "1'",
  fiveMinutes: "5'",
  infinite: "Infini",
  buttons: "Boutons",
  piano: "Piano",
  trebleClef: "Sol",
  bassClef: "Fa",
  altoClef: "Ut (3e)",
  tenorClef: "Ut (4e)",
  pianoClef: "Piano",
  both: "les deux",
  easy: "Facile",
  normal: "Moyen",
  hard: "Difficile",
  none: "Aucune",
  sharp: "♯",
  flat: "♭",
  sharpAndFlat: "♯ et ♭",
  SOUND: "SON",
  VIBRATION: "VIBRATION",
  DISPLAYCORRECTNOTE: "AFFICHER LA NOTE CORRECTE",
  on: "Activé",
  off: "Désactivé",

  TIME: "TEMPS",
  CORRECT: "JUSTES",
  ACCURACY: "PRÉCISION",
  SCORE: "POINTS",

  record: "Record",
  history: "Historique"
};



// WEBPACK FOOTER //
// ./src/resources/fr.js